import { jsx as _jsx } from "react/jsx-runtime";
import { useEmailVerification } from '../http-initiate-verification/useEmailVerification';
import imageUrls from '../images/imageUrls';
import { useTracker } from '../tracking/useTracker';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';

const EmailVerificationStandardError = () => {
  const {
    resendEmail
  } = useEmailVerification();
  const Tracker = useTracker();

  const onClickResendEmailHandler = () => {
    Tracker.signupInteraction('retry-send-verification-email');
    resendEmail();
  };

  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.EmailVerificationFailed,
    handleButtonClick: onClickResendEmailHandler,
    imageURL: imageUrls.emailWarning
  });
};

export default EmailVerificationStandardError;